import { Fragment, useEffect, useState } from "react";
import WebDesigner from "../WebDesigner";
import { LeftCaret } from "./ComponentContextMenu";
import { EditorState, PannelMenuType } from "../EditorTypes";
import ConnectDomainClickAd from "../Adds/ConnectDomainClickAd";
import store from "app/store";
import { StyleBuilderState } from "../Stylebuilder";
import { MultiLocationLive } from "components/Multilocation/MulitLocationLIve";
import { LoginUserType } from "utils/Utils";
import { BlogBrowserWrapper } from "./BlogBrowser";



export enum SettingsMenuOptionType{

    OpenLeftPanel,
    OpenRightPanel,
    OpenSubMenu,
}

export enum SettingsSubMenu{
    None,
    SiteStyling,
    AnnouncementTools
}




export default function SettingsMenuRedo({designer,startInStyle}:{designer:WebDesigner,startInStyle?:boolean}) {
    const { IsPurchasedDomain,IsMutipleLocation } = store.getState().Business;
    let {reactBusinessId } = designer.props;

    const mainMenuItems = [
        {label:"General",onSelect:()=>{openLeftPanel(PannelMenuType.GeneralSettings)},ShowAdmin:false},
        {label:"Domains",onSelect:()=>{openLeftPanel(PannelMenuType.Domains)},ShowAdmin:false},
        {label:"Change Theme",onSelect:()=>{

            let windowLocationnew = window.location.href;       
            let folder = windowLocationnew.indexOf("admin/") > 0 ? "admin" : "business";
            let styleid =  designer.props.styleId;
            let layoutid =  designer.props.layoutId;
         

            window.open('/' + folder + '/' + styleid + "/" + layoutid + "/changestyle","_self");
        
        }},
        {label:"Change Layout",onSelect:()=>{

            let windowLocationnew = window.location.href;       
            let folder = windowLocationnew.indexOf("admin/") > 0 ? "admin" : "business";
            let styleid =  designer.props.styleId;
            let layoutid =  designer.props.layoutId;
         

            window.open('/' + folder + '/' + styleid + "/" + layoutid + "/changelayout","_self");
        
        }},
        {label:"Editor Preferences",onSelect:()=>{openLeftPanel(PannelMenuType.EditorSettings)},ShowAdmin:true},
        {label:"Site Styling",onSelect:()=>{
            setSubMenu(SettingsSubMenu.SiteStyling);
            setSelectedMenuItem("Fonts");
            openRightPanel(1);
        
        },ShowAdmin:true},
        {label:"Announcement Tools",onSelect:()=>{
            setSubMenu(SettingsSubMenu.AnnouncementTools);
            setSelectedMenuItem("Announcement Bar");
            openRightPanel(StyleBuilderState.AnnouncementBar);

        }},
 
     
        {label:"Version History",onSelect:()=>{
            designer.openToPannelMenu(PannelMenuType.None);
            setSelectedMenuItem("");
            designer.deselectAll();
            designer.openToVersionHistory();
        },ShowAdmin:false},
        {label:"Cookie Banner",onSelect:()=>{openRightPanel(10); openLeftPanel(PannelMenuType.None); setTimeout(()=>{designer.deselectAll()})},ShowAdmin:false},

        {label:"Blogging",onSelect:()=>{
            designer.setState({styleMenuState:StyleBuilderState.SelectedComponent});
            openLeftPanel(PannelMenuType.None);
          
        },ShowAdmin:false},

    ]

    if(MultiLocationLive||designer.props.siteData.userContext.userType == LoginUserType.VagaroAdmin){
        mainMenuItems.splice(mainMenuItems.length-2,0,
        {label:"Multi-Location",onSelect:()=>{openLeftPanel(PannelMenuType.Multilocation)},ShowAdmin:false}
        )
    }




    const siteStylingMenu = [

      {label:"Fonts",onSelect:()=>{openRightPanel(1)},ShowAdmin:true},
      {label:"Colors",onSelect:()=>{openRightPanel(2)},ShowAdmin:true},
      {label:"Headings",onSelect:()=>{openRightPanel(3)},ShowAdmin:true},
      {label:"Paragraphs",onSelect:()=>{openRightPanel(4)},ShowAdmin:true},
      {label:"Buttons",onSelect:()=>{openRightPanel(5)},ShowAdmin:true},
      {label:"Links",onSelect:()=>{openRightPanel(6)},ShowAdmin:true},
      {label:"Page Spacing",onSelect:()=>{openRightPanel(7)},ShowAdmin:true},
      {label:"Image Mapping",onSelect:()=>{openRightPanel(8)},ShowAdmin:true},
    ]

    const AnnouncementToolsMenu = [
            
            {label:"Announcement Bar",onSelect:()=>{openRightPanel(StyleBuilderState.AnnouncementBar)},ShowAdmin:true},
            // {label:"Cookie Banner",onSelect:()=>{openRightPanel(StyleBuilderState.CookieBanner)},ShowAdmin:true},
            {label:"Pop-up",onSelect:()=>{openRightPanel(StyleBuilderState.Popup)},ShowAdmin:true},
    ]

    if(!designer.props.siteData.userContext.isAdmin)//remove image mapping for non admin users
     siteStylingMenu.pop();

 

    const startMenu = startInStyle?SettingsSubMenu.SiteStyling:SettingsSubMenu.None;
    const startSelection = startInStyle?"Fonts":"";
    const [selectedMenuItem,setSelectedMenuItem] = useState<string>(startSelection);
    const [subMenu,setSubMenu] = useState<SettingsSubMenu>(startMenu);


    let currentMenu: {label:string,onSelect:()=>void,ShowAdmin?:boolean}[] = mainMenuItems;
    let currentTitle = "Settings";
    if(subMenu == SettingsSubMenu.SiteStyling){
        currentMenu = siteStylingMenu;
        currentTitle = "Site Styling";
    }
    else if(subMenu == SettingsSubMenu.AnnouncementTools){
        currentTitle = "Announcement Tools";
        currentMenu = AnnouncementToolsMenu;
    }
 
    
    designer.onDeselectMenu = ()=>{
    
    
        setSelectedMenuItem("");

    }

    designer.openToAnnouncementBar = ()=>{
        openRightPanel(9);
        setSelectedMenuItem("Announcement Bar");
        setSubMenu(SettingsSubMenu.None);
        setTimeout(()=>{designer.deselectAll()})
    }

    designer.openToMultiLocationSettings = ()=>{

        designer.openSettingsMenu();
      

        openLeftPanel(PannelMenuType.Multilocation);
        setSubMenu(SettingsSubMenu.None);
        setSelectedMenuItem("Multi-Location");

    }

    designer.openToDomainSettings = ()=>{


        designer.openSettingsMenu();

      
        openLeftPanel(PannelMenuType.Domains);
        setSubMenu(SettingsSubMenu.None);
        setSelectedMenuItem("Domains");
       
      

    }

    designer.openToBlogSettings = ()=>{
        designer.openSettingsMenu();
    
        setSubMenu(SettingsSubMenu.None);
        setSelectedMenuItem("Blogging");
    }

    (window as any).OpenToBlogSettings = designer.openToBlogSettings;


    const selectOption = (item:{label:string,onSelect?:Function})=>{

        const execute = ()=>{
            setSelectedMenuItem(item.label);
            if(item.onSelect)
                item.onSelect();
        }
        
        if(designer.panelMenuLocked)
            designer.promptForPanelExit(execute);
        else
            execute();
    }

    const openRightPanel = (state:number)=>{

  
        if(designer.state.editSate===EditorState.InPannelMenu)
            designer.switchToEditorState(EditorState.Normal)

        designer.openToPannelMenu(PannelMenuType.None);

        designer.switchToMenuState(state);
        designer.setState({rightPannelExpanded:true});
    }

    const openLeftPanel = (state:PannelMenuType)=>{
        designer.openToPannelMenu(state);

    }


    useEffect(()=>{

        if(startInStyle){
            openRightPanel(1);
        }
//eslint-disable-next-line
    },[])

  

    return (

        <>
{
    selectedMenuItem == "Blogging" && <BlogBrowserWrapper 
    onOpenPost={(post:string)=>{
        designer.trySwitchPage(post,()=>{},true);
        setSelectedMenuItem("");
    }}
    currentPost={designer.state.currentPageId}
    onCreatePost={()=>{

    }}
    
    onClose={()=>setSelectedMenuItem("")}  context={designer.props.siteData.userContext} />
}

    {subMenu == SettingsSubMenu.None?
         <h2 className="tab-title panel-heading">{currentTitle}</h2>:
         <h2 className="panel-heading" style={{cursor:"pointer"}} onClick={()=>{setSubMenu(SettingsSubMenu.None);  openRightPanel(StyleBuilderState.SelectedComponent); 
            
            setTimeout(()=>designer.autoToggleRightPanel(false),0); }}><LeftCaret/>{currentTitle}</h2>
    }
    {
        subMenu == SettingsSubMenu.None&&          <ConnectDomainClickAd DomainNotPurcheshed={IsPurchasedDomain === false} designer={designer}/>
    }
        <div className="tab-links relative bottom-white-fade" style={{background:"white",zIndex:1}}>{
            currentMenu.map((item,index)=>{
                if (reactBusinessId > 0 || item.ShowAdmin === true) {
                    return(
                        item.label != "Multi-Location" ?
                        <button key={item.label + index}className={ "invisible-button tab-link "+(item.label===selectedMenuItem?"active":"")} onClick={()=>{ selectOption(item)}}>
                         {item.label}
                         {item.label == "Blogging" &&  <span className='badge bg-success ms-2'>NEW</span>}
                         </button>               
                         : (IsMutipleLocation && <Fragment key={index}> <button key={item.label}className={ "invisible-button tab-link "+(item.label===selectedMenuItem?"active":"")} onClick={()=>{ selectOption(item)}}>
                                                    {item.label}</button>  </Fragment>
                    )
                    )
                }
                else {
                    return null;
                }
            })
        }</div>
        </>



    )














}